import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Logo = function(_param) {
    var isDark = _param.isDark, props = _object_without_properties(_param, [
        "isDark"
    ]);
    var textColor = isDark ? "#FFFFFF" : "#000000";
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 816 323"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M161.5 323C250.694 323 323 250.694 323 161.5C323 72.306 250.694 0 161.5 0C72.306 0 0 72.306 0 161.5C0 250.694 72.306 323 161.5 323Z",
                fill: "url(#paint0_radial_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M46.9566 182.34H275.775C276.628 178.609 277.321 174.772 277.854 170.881H44.9312C45.4109 174.772 46.1038 178.556 46.9566 182.34Z",
                fill: "url(#paint1_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M68.5964 227.699H254.135C255.947 225.354 257.706 222.955 259.358 220.45H63.4263C65.0786 222.902 66.7842 225.354 68.5964 227.699Z",
                fill: "url(#paint2_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M82.6675 242.783H240.17C242.249 240.917 244.274 238.945 246.193 236.92H76.6445C78.5633 238.999 80.5888 240.917 82.6675 242.783Z",
                fill: "url(#paint3_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M103.614 257.921H219.223C221.675 256.535 224.073 255.042 226.472 253.497H96.4189C98.7109 255.042 101.163 256.535 103.614 257.921Z",
                fill: "url(#paint4_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M51.5937 197.425H271.191C272.417 194.12 273.536 190.816 274.496 187.351H48.2891C49.2485 190.816 50.3678 194.174 51.5937 197.425Z",
                fill: "url(#paint5_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M58.6289 212.561H264.155C265.701 209.736 267.193 206.858 268.472 203.927H54.2583C55.5908 206.858 57.0832 209.736 58.6289 212.561Z",
                fill: "url(#paint6_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M43.9185 155.637C43.9185 159.528 44.1317 163.419 44.5048 167.203H278.333C278.706 163.419 278.92 159.528 278.92 155.637C278.92 155.211 278.92 154.784 278.92 154.358H43.9185C43.9185 154.784 43.9185 155.211 43.9185 155.637Z",
                fill: "url(#paint7_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M45.2514 137.835C44.5585 142.525 44.1321 147.269 43.9722 152.066H278.813C278.654 147.216 278.227 142.472 277.534 137.835H45.2514Z",
                fill: "url(#paint8_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M157.715 273.058H165.07C173.012 272.791 180.794 271.778 188.309 270.02H134.476C141.991 271.778 149.719 272.791 157.715 273.058Z",
                fill: "url(#paint9_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M161.392 38.1631C102.868 38.1631 54.3651 80.9632 45.4106 136.982H277.374C268.419 80.9632 219.916 38.1631 161.392 38.1631Z",
                fill: "url(#paint10_linear_193_1319)"
            }),
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_193_1319)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M491.656 112.258L457.07 214.975H487.516L490.837 205.211H523.181L526.501 214.975H556.948L522.103 112.258H491.656ZM497.435 185.812L507.009 157.595L516.582 185.812H497.435Z",
                        fill: "url(#paint11_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M528.356 212.394L525.035 202.63H488.983L485.662 212.394H460.649L493.511 114.839H520.248L553.368 212.394H528.356ZM493.856 188.35H520.205L507.052 149.551L493.856 188.35Z",
                        fill: "url(#paint12_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M529.779 168.821C527.191 169.725 525.898 172.65 523.138 172.865C520.119 173.123 516.712 169.079 514.038 168.09C513.78 168.004 513.478 167.918 513.219 167.832L520.205 188.393H493.856L499.807 170.886C499.031 171.359 498.125 171.617 496.875 171.488C494.071 171.187 492.26 168.348 489.716 167.273C483.894 164.864 479.797 168.735 474.794 170.413L460.649 212.437H485.662L488.983 202.673H525.035L528.356 212.437H553.368L538.706 169.208C538.404 169.122 538.059 169.036 537.714 168.95C535.515 168.348 531.978 168.047 529.779 168.821Z",
                        fill: "url(#paint13_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M612.191 112L589.205 147.831V112.215H560.354V215.233H589.205V179.876L611.846 215.19H646.13L613.183 163.875L646.475 112H612.191Z",
                        fill: "url(#paint14_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M562.899 212.652V114.753H586.618V156.605L613.614 114.581H641.775L610.164 163.875L641.43 212.652H613.269L586.661 171.144V212.652H562.899Z",
                        fill: "url(#paint15_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M586.661 171.101L613.269 212.61H641.429L610.164 163.875L613.01 159.444C612.406 159.229 611.759 159.1 611.069 159.057C606.929 158.928 604.946 162.929 601.237 163.015C596.364 163.144 595.07 158.67 589.636 161.122C583.599 163.875 585.41 162.455 579.545 160.133C574.542 158.197 574.197 162.67 570.273 162.498C569.022 162.455 566.866 159.918 565.314 159.53C564.365 159.315 563.632 159.315 562.985 159.401V212.653H586.704V171.101H586.661Z",
                        fill: "url(#paint16_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M433.998 180.22C433.998 184.564 430.462 188.092 426.106 188.092C421.75 188.092 418.214 184.564 418.214 180.22V172.306H389.363V180.22C389.363 200.437 405.837 216.911 426.149 216.911C446.418 216.911 462.935 200.48 462.935 180.22V113.764H434.084V180.22H433.998Z",
                        fill: "url(#paint17_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M426.106 214.33C407.26 214.33 391.908 199.017 391.908 180.22V174.886H415.627V180.22C415.627 185.984 420.327 190.672 426.106 190.672C431.885 190.672 436.585 185.984 436.585 180.22V116.302H460.304V180.22C460.261 199.06 444.952 214.33 426.106 214.33Z",
                        fill: "url(#paint18_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M426.106 214.33C444.952 214.33 460.304 199.017 460.304 180.22V159.444C459.614 159.702 458.924 159.788 457.286 159.53C455.216 159.186 453.965 157.552 451.636 157.767C449.135 157.982 448.531 160.176 446.72 160.563C443.442 161.337 442.106 158.67 438.742 158.154C437.965 158.025 437.232 158.068 436.542 158.154V180.22C436.542 185.984 431.842 190.672 426.063 190.672C420.284 190.672 415.584 185.984 415.584 180.22V174.886H391.865V180.22C391.908 199.06 407.217 214.33 426.106 214.33Z",
                        fill: "url(#paint19_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M271.933 115.398L256.15 168.305L240.366 115.398H238.813H210.265H208.669L192.885 168.305L177.101 115.398H147L177.834 218.847L177.748 219.148H177.921H207.85H208.065L207.936 218.847L224.539 163.23L241.099 218.847L241.013 219.148H241.185H271.114H271.33L271.2 218.847L302.035 115.398H271.933Z",
                        fill: "url(#paint20_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M243.126 216.61L224.539 154.24L205.952 216.61H179.862L150.45 117.936H175.204L192.885 177.338L210.61 117.936H238.469L256.15 177.338L273.874 117.936H298.585L269.217 216.61H243.126Z",
                        fill: "url(#paint21_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M210.955 168.477C208.971 168.864 207.893 170.413 205.952 171.058C202.2 172.305 198.707 169.94 195.343 169.079L192.885 177.295L190.686 169.854C189.608 170.843 188.4 172.392 187.236 172.865C183.613 174.37 178.999 173.338 175.333 172.09C172.53 171.144 171.538 169.854 168.304 169.768C167.528 169.768 166.708 169.811 165.932 169.854L179.862 216.61H205.952L219.882 169.854C216.949 168.864 213.844 167.918 210.955 168.477Z",
                        fill: "url(#paint22_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M279.912 169.897C277.238 170.069 275.125 169.123 272.624 169.123C269.648 169.08 269.174 171.058 266.586 171.832C263.481 172.736 261.152 170.542 258.392 169.94L256.193 177.338L254.08 170.284C253.217 170.671 252.398 171.23 251.147 171.875C244.118 175.403 242.307 169.768 235.795 169.897C233.207 169.94 231.569 170.843 229.628 171.316L243.126 216.61H269.217L283.146 169.94C282.068 169.854 280.99 169.854 279.912 169.897Z",
                        fill: "url(#paint23_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M340.071 115.828C314.326 115.828 293.453 138.884 293.453 167.273C293.453 195.705 314.326 218.717 340.071 218.717C365.817 218.717 386.69 195.662 386.69 167.273C386.69 138.841 365.817 115.828 340.071 115.828ZM340.071 186.113C330.67 186.113 322.994 177.682 322.994 167.273C322.994 156.863 330.627 148.433 340.071 148.433C349.473 148.433 357.149 156.863 357.149 167.273C357.149 177.682 349.516 186.113 340.071 186.113Z",
                        fill: "url(#paint24_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M340.071 216.179C315.792 216.179 296.041 194.242 296.041 167.273C296.041 140.303 315.792 118.366 340.071 118.366C364.351 118.366 384.102 140.303 384.102 167.273C384.145 194.242 364.394 216.179 340.071 216.179ZM340.071 145.895C329.247 145.895 320.449 155.487 320.449 167.273C320.449 179.059 329.247 188.694 340.071 188.694C350.896 188.694 359.693 179.102 359.693 167.273C359.736 155.487 350.896 145.895 340.071 145.895Z",
                        fill: "url(#paint25_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M382.938 163.66C378.237 164.09 373.364 166.671 368.577 165.853C365.774 165.38 364.264 163.1 361.375 163.272C360.728 163.315 360.081 163.488 359.391 163.66C359.564 164.821 359.693 166.025 359.693 167.273C359.693 179.059 350.896 188.694 340.071 188.694C329.247 188.694 320.449 179.102 320.449 167.273C320.449 166.843 320.492 166.412 320.492 165.939C318.293 165.38 316.094 164.95 313.549 165.294C310.272 165.767 305.873 168.563 302.682 167.531C300.871 166.929 300.224 164.692 298.283 164.133C297.55 163.918 296.86 163.961 296.127 164.047C296.084 165.122 296.041 166.197 296.041 167.273C296.041 194.242 315.792 216.179 340.071 216.179C364.351 216.179 384.102 194.242 384.102 167.273C384.102 166.025 384.059 164.821 383.973 163.617C383.671 163.617 383.326 163.617 382.938 163.66Z",
                        fill: "url(#paint26_linear_193_1319)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M561.303 261C561.001 261.043 560.699 261.043 560.441 260.957C559.492 260.699 559.104 259.666 559.578 258.677C564.796 247.752 573.637 232.998 582.132 218.717C594.294 198.286 612.708 167.402 608.568 164.262C608.223 164.004 607.447 164.004 606.369 164.176C594.337 166.585 555.309 196.479 543.492 209.555H543.536C544.571 209.641 545.131 210.545 544.872 211.577C544.571 212.609 543.492 213.384 542.501 213.298C541.552 213.212 539.568 212.652 539.137 211.19C538.878 210.373 539.137 209.469 539.784 208.652C550.047 196.479 591.836 163.444 606.369 160.563C608.525 160.175 610.207 160.347 611.328 161.165C617.323 165.724 605.377 186.543 585.41 220.094C576.957 234.288 568.203 248.956 563.071 259.71C562.683 260.355 561.993 260.828 561.303 261Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M546.468 240.052C545.562 240.224 544.786 239.794 544.57 238.977C544.355 238.031 545.001 236.912 546.036 236.525C555.653 232.74 585.28 222.847 591.533 221.212C592.568 220.954 593.517 221.513 593.603 222.503C593.69 223.492 592.913 224.524 591.835 224.825C586.358 226.288 556.731 236.095 546.856 239.966C546.726 240.009 546.597 240.009 546.468 240.052Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M559.06 259.279C558.759 259.322 558.457 259.322 558.198 259.236C557.249 258.978 556.861 257.946 557.335 256.957C562.554 246.031 571.394 231.277 579.89 216.997C592.051 196.565 610.466 165.681 606.326 162.541C605.981 162.283 605.204 162.283 604.126 162.455C592.094 164.864 553.066 194.759 541.25 207.835H541.293C542.328 207.921 542.888 208.824 542.63 209.857C542.328 210.889 541.25 211.663 540.258 211.577C539.309 211.491 537.325 210.932 536.894 209.469C536.635 208.652 536.894 207.749 537.541 206.932C547.805 194.759 589.593 161.724 604.126 158.842C606.282 158.455 607.964 158.627 609.086 159.444C615.08 164.004 603.134 184.822 583.167 218.373C574.715 232.568 565.96 247.236 560.829 257.989C560.44 258.634 559.794 259.15 559.06 259.279Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M544.226 238.375C543.32 238.547 542.544 238.117 542.328 237.299C542.112 236.353 542.759 235.235 543.794 234.848C553.411 231.062 583.038 221.169 589.291 219.535C590.326 219.277 591.275 219.836 591.361 220.825C591.448 221.814 590.671 222.847 589.593 223.148C584.116 224.61 554.489 234.417 544.614 238.289C544.484 238.289 544.355 238.332 544.226 238.375Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M677.18 229.557C676.576 229.686 676.059 229.6 675.541 229.342C675.11 229.127 674.55 228.654 674.377 227.664C674.075 225.686 675.843 221.771 679.336 215.964C668.771 227.707 661.871 234.202 658.033 231.277C651.607 226.374 666.787 207.018 668.512 204.824C672.523 199.791 682.398 188.35 687.228 191.102C689.6 192.436 687.746 197.641 686.236 200.092C685.676 201.039 684.468 201.512 683.563 201.125C682.657 200.738 682.398 199.662 683.002 198.716C683.951 197.124 684.468 195.232 684.511 194.415C682.312 194.759 673.903 202.243 666.442 213.427C660.922 221.728 659.369 227.105 660.706 228.137C662.647 229.643 676.706 213.728 681.967 207.706C685.59 203.576 689.04 199.705 692.058 196.522C692.791 195.748 693.913 195.533 694.646 196.049C695.379 196.565 695.465 197.598 694.905 198.458L693.87 199.963C690.333 205.125 680.371 219.664 678.431 224.911C682.096 221.857 690.204 212.437 695.81 205.899C701.977 198.759 707.756 192.006 711.249 188.952C712.111 188.178 713.319 188.134 713.923 188.823C714.57 189.511 714.354 190.715 713.491 191.447C710.257 194.285 704.306 201.211 698.527 207.921C685.503 223.363 680.242 228.998 677.18 229.557Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M674.981 227.879C674.377 228.008 673.86 227.922 673.342 227.664C672.911 227.449 672.35 226.976 672.178 225.987C671.876 224.008 673.644 220.094 677.137 214.287C666.572 226.03 659.672 232.525 655.833 229.6C649.408 224.696 664.588 205.34 666.313 203.146C670.323 198.114 680.199 186.672 685.029 189.425C687.401 190.758 685.547 195.963 684.037 198.415C683.477 199.361 682.269 199.834 681.363 199.447C680.458 199.06 680.199 197.985 680.803 197.038C681.752 195.447 682.269 193.554 682.312 192.737C680.113 193.081 671.703 200.566 664.243 211.749C658.723 220.051 657.17 225.428 658.507 226.46C660.448 227.965 674.507 212.05 679.768 206.028C683.39 201.899 686.84 198.028 689.859 194.845C690.592 194.07 691.713 193.855 692.447 194.372C693.18 194.888 693.266 195.92 692.705 196.78L691.67 198.286C688.134 203.447 678.172 217.986 676.232 223.234C679.897 220.18 688.005 210.76 693.611 204.222C699.778 197.081 705.557 190.328 709.05 187.274C709.912 186.5 711.12 186.457 711.724 187.145C712.37 187.833 712.155 189.038 711.292 189.769C708.058 192.608 702.107 199.533 696.328 206.243C683.261 221.685 678.043 227.32 674.981 227.879Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M741.221 216.997C741.091 216.997 741.005 217.04 740.876 217.04C739.108 217.298 738.029 216.696 737.469 216.179C732.509 211.62 738.892 200.694 743.161 194.587C748.207 187.317 757.953 176.22 762.568 177.424C763.818 177.725 764.638 178.542 764.983 179.747C765.673 182.242 763.948 186.07 762.568 188.048C761.921 188.995 760.713 189.382 759.851 188.909C758.988 188.479 758.816 187.36 759.463 186.414C760.541 184.865 761.489 182.371 761.188 181.338C761.144 181.123 761.058 181.08 760.886 181.037C758.514 181.209 747.646 192.221 742.126 202.845C739.453 208.007 738.806 211.835 740.358 213.255C740.401 213.298 740.531 213.427 741.048 213.341C745.835 212.609 758.514 201.254 778.74 179.403C780.163 177.854 781.284 176.65 781.888 176.005C782.664 175.187 783.915 175.015 784.605 175.66C785.295 176.306 785.251 177.467 784.432 178.284C783.828 178.929 782.75 180.048 781.327 181.596C765.975 198.329 749.113 215.534 741.221 216.997Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M738.978 215.319C738.849 215.319 738.763 215.362 738.634 215.362C736.865 215.62 735.787 215.018 735.227 214.502C730.267 209.943 736.65 199.017 740.919 192.909C745.965 185.64 755.711 174.542 760.325 175.746C761.576 176.048 762.395 176.865 762.74 178.069C763.43 180.564 761.705 184.392 760.325 186.371C759.679 187.317 758.471 187.704 757.609 187.231C756.746 186.801 756.574 185.683 757.22 184.736C758.299 183.188 759.247 180.693 758.945 179.661C758.902 179.446 758.816 179.403 758.644 179.36C756.272 179.532 745.404 190.543 739.884 201.168C737.21 206.329 736.563 210.158 738.116 211.577C738.159 211.62 738.289 211.749 738.806 211.663C743.593 210.932 756.272 199.576 776.497 177.725C777.92 176.177 779.042 174.972 779.646 174.327C780.422 173.51 781.672 173.338 782.362 173.983C783.052 174.628 783.009 175.79 782.19 176.607C781.586 177.252 780.508 178.37 779.085 179.919C763.732 196.608 746.914 213.814 738.978 215.319Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M768.648 214.416C768.605 214.416 768.562 214.416 768.476 214.459C767.053 214.674 766.19 214.244 765.759 213.814C763.517 211.792 763.387 208.007 765.328 202.587C769.511 190.887 782.794 173.252 789.047 171.101C790.944 170.456 791.979 171.144 792.454 171.617C793.144 172.348 793.834 173.682 793.187 176.048C791.203 182.93 777.705 195.017 773.996 196.952C773.22 197.383 772.357 197.254 771.84 196.78C771.409 197.641 770.977 198.458 770.546 199.318C767.786 205.082 767.096 209.254 768.562 210.76C773.047 210.803 797.887 186.371 812.679 169.682C813.455 168.821 814.663 168.606 815.396 169.165C816.129 169.725 816.129 170.886 815.396 171.746C815.051 172.176 778.783 212.523 768.648 214.416ZM789.564 174.628C787.235 175.402 779.818 183.403 774.125 192.823C778.395 189.683 788.141 180.435 789.478 175.704C789.65 175.144 789.607 174.8 789.564 174.628Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M766.406 212.739C766.363 212.739 766.32 212.739 766.233 212.782C764.81 212.997 763.948 212.566 763.516 212.136C761.274 210.115 761.145 206.329 763.085 200.91C767.268 189.21 780.551 171.574 786.804 169.424C788.702 168.778 789.737 169.467 790.211 169.94C790.901 170.671 791.591 172.004 790.944 174.37C788.96 181.252 775.462 193.339 771.753 195.275C770.977 195.705 770.115 195.576 769.597 195.103C769.166 195.963 768.735 196.78 768.303 197.641C765.543 203.405 764.853 207.577 766.32 209.082C770.805 209.125 795.645 184.694 810.437 168.004C811.213 167.144 812.42 166.929 813.153 167.488C813.887 168.047 813.887 169.209 813.153 170.069C812.808 170.499 776.54 210.803 766.406 212.739ZM787.322 172.951C784.993 173.725 777.575 181.726 771.883 191.146C776.152 188.006 785.898 178.758 787.235 174.026C787.408 173.424 787.365 173.123 787.322 172.951Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M595.458 250.161C595.027 250.247 594.639 250.204 594.251 250.118C593.043 249.773 592.181 248.913 591.836 247.623C590.111 241.3 601.064 223.234 607.749 213.04C608.352 212.093 609.56 211.663 610.422 212.093C611.285 212.523 611.501 213.599 610.897 214.545C600.806 229.944 594.639 242.59 595.587 245.988C595.631 246.117 595.674 246.203 595.717 246.289C597.701 244.956 603.091 238.676 607.878 233.084C614.519 225.342 622.756 215.663 630.476 208.609C631.338 207.835 632.546 207.749 633.193 208.437C633.839 209.125 633.667 210.287 632.804 211.061C625.301 217.9 617.15 227.406 610.638 235.063C601.797 245.429 598.089 249.687 595.458 250.161Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M613.484 207.19C612.622 207.362 611.889 206.975 611.63 206.2C609.948 200.824 621.721 188.479 622.799 187.834C623.662 187.317 624.783 187.403 625.257 188.092C626.077 189.253 625.128 190.586 623.576 192.866L623.274 193.296C622.799 194.028 621.98 194.415 621.204 194.372C618.271 197.942 614.821 202.931 615.296 204.48C615.597 205.383 614.994 206.502 613.959 206.975C613.829 207.104 613.657 207.19 613.484 207.19Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M593.258 248.483C592.827 248.569 592.439 248.526 592.051 248.44C590.843 248.096 589.981 247.235 589.636 245.945C587.911 239.622 598.865 221.556 605.549 211.362C606.153 210.416 607.36 209.985 608.223 210.416C609.085 210.846 609.301 211.921 608.697 212.867C598.606 228.266 592.439 240.912 593.388 244.31C593.431 244.44 593.474 244.526 593.517 244.612C595.501 243.278 600.891 236.998 605.678 231.406C612.32 223.664 620.557 213.986 628.276 206.931C629.138 206.157 630.346 206.071 630.993 206.759C631.64 207.448 631.467 208.609 630.605 209.383C623.101 216.222 614.95 225.729 608.438 233.385C599.598 243.751 595.846 247.967 593.258 248.483Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M611.285 205.512C610.422 205.684 609.689 205.297 609.43 204.523C607.748 199.146 619.521 186.801 620.6 186.156C621.462 185.64 622.583 185.726 623.058 186.414C623.877 187.575 622.928 188.909 621.376 191.188L621.074 191.619C620.6 192.35 619.78 192.737 619.004 192.694C616.071 196.264 612.622 201.254 613.096 202.802C613.398 203.705 612.794 204.824 611.759 205.297C611.63 205.426 611.457 205.469 611.285 205.512Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M638.54 238.332C637.979 238.418 637.505 238.332 637.117 238.117C631.812 235.364 638.152 224.782 648.114 210.029C637.85 219.707 625.387 233.901 620.47 239.45C619.867 240.138 618.918 240.439 618.142 240.181C617.409 239.923 617.02 239.149 617.236 238.332C618.444 233.428 624.222 222.159 634.874 203.835L635.176 203.319C635.737 202.372 636.944 201.856 637.85 202.243C638.755 202.587 639.014 203.663 638.454 204.652L638.152 205.168C632.157 215.491 627.672 223.621 624.783 229.471C635.176 217.9 647.294 205.125 655.186 199.705C655.962 199.189 656.911 199.146 657.515 199.662C658.119 200.179 658.162 201.082 657.687 201.856C656.394 204.007 654.539 206.76 652.34 209.943C648.243 215.965 637.764 231.45 639.014 234.375C643.025 231.794 657.472 215.965 665.45 207.233C670.107 202.157 674.118 197.727 676.317 195.576C677.137 194.759 678.344 194.63 679.034 195.275C679.724 195.92 679.638 197.082 678.819 197.899C676.706 200.006 672.738 204.351 668.124 209.383C647.726 231.751 641.516 237.773 638.54 238.332Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M636.298 236.611C635.737 236.697 635.263 236.611 634.875 236.396C629.57 233.643 635.91 223.062 645.872 208.308C635.608 217.986 623.145 232.181 618.228 237.729C617.625 238.418 616.676 238.719 615.9 238.461C615.166 238.203 614.778 237.428 614.994 236.611C616.201 231.708 621.98 220.438 632.632 202.114L632.934 201.598C633.495 200.652 634.702 200.135 635.608 200.522C636.513 200.867 636.772 201.942 636.211 202.931L635.91 203.447C629.915 213.771 625.43 221.9 622.541 227.75C632.934 216.18 645.052 203.404 652.944 197.985C653.72 197.468 654.669 197.425 655.273 197.942C655.877 198.458 655.92 199.361 655.445 200.135C654.152 202.286 652.297 205.039 650.098 208.222C646.001 214.244 635.521 229.729 636.772 232.654C640.783 230.073 655.23 214.244 663.208 205.512C667.865 200.436 671.876 196.006 674.075 193.855C674.895 193.038 676.102 192.909 676.792 193.554C677.482 194.199 677.396 195.361 676.577 196.178C674.463 198.286 670.496 202.63 665.882 207.663C645.483 230.073 639.273 236.052 636.298 236.611Z",
                        fill: "#FEF5FF"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M714.268 225.299C713.707 225.385 713.233 225.299 712.845 225.084C707.54 222.331 713.88 211.749 723.842 196.995C713.578 206.674 701.115 220.868 696.198 226.417C695.595 227.105 694.646 227.406 693.87 227.148C693.137 226.89 692.748 226.116 692.964 225.299C694.172 220.395 699.95 209.125 710.602 190.801L710.904 190.285C711.465 189.339 712.672 188.823 713.578 189.21C714.484 189.554 714.742 190.629 714.182 191.619L713.88 192.135C707.885 202.458 703.4 210.588 700.511 216.438C710.904 204.867 723.022 192.092 730.914 186.672C731.69 186.156 732.639 186.113 733.243 186.629C733.847 187.145 733.89 188.049 733.415 188.823C732.122 190.974 730.267 193.726 728.068 196.909C723.971 202.931 713.492 218.416 714.742 221.341C718.753 218.76 733.2 202.931 741.178 194.2C745.836 189.124 749.846 184.694 752.046 182.543C752.865 181.726 754.072 181.597 754.762 182.242C755.452 182.887 755.366 184.048 754.547 184.866C752.434 186.973 748.466 191.318 743.852 196.35C723.454 218.717 717.244 224.739 714.268 225.299Z",
                        fill: "#D3D3D3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M712.068 223.578C711.508 223.664 711.033 223.578 710.645 223.363C705.341 220.61 711.68 210.029 721.642 195.275C711.378 204.953 698.915 219.147 693.999 224.696C693.395 225.384 692.446 225.686 691.67 225.428C690.937 225.169 690.549 224.395 690.764 223.578C691.972 218.674 697.751 207.405 708.403 189.081L708.704 188.565C709.265 187.618 710.473 187.102 711.378 187.489C712.284 187.833 712.543 188.909 711.982 189.898L711.68 190.414C705.686 200.738 701.201 208.867 698.311 214.717C708.704 203.146 720.823 190.371 728.715 184.951C729.491 184.435 730.44 184.392 731.043 184.908C731.647 185.425 731.69 186.328 731.216 187.102C729.922 189.253 728.068 192.006 725.868 195.189C721.771 201.211 711.292 216.696 712.543 219.621C716.553 217.04 731 201.211 738.978 192.479C743.636 187.403 747.646 182.973 749.846 180.822C750.665 180.005 751.873 179.876 752.563 180.521C753.253 181.166 753.166 182.328 752.347 183.145C750.234 185.253 746.266 189.597 741.652 194.63C721.211 217.04 715.044 223.019 712.068 223.578Z",
                        fill: "#FEF5FF"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint0_radial_193_1319",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(161.507 161.507) scale(161.507)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F24E61"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4064",
                                stopColor: "#EA4B5E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5376",
                                stopColor: "#EC3369",
                                stopOpacity: "0.779"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7147",
                                stopColor: "#EE1975",
                                stopOpacity: "0.4807"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8742",
                                stopColor: "#F0097C",
                                stopOpacity: "0.2119"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F0047F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_193_1319",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_193_1319",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1687",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_193_1319",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1699",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_193_1319",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1689",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint5_linear_193_1319",
                        x1: "161.402",
                        y1: "273.106",
                        x2: "161.402",
                        y2: "38.1703",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint6_linear_193_1319",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint7_linear_193_1319",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1704",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint8_linear_193_1319",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1694",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint9_linear_193_1319",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1692",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint10_linear_193_1319",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1697",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint11_linear_193_1319",
                        x1: "507.02",
                        y1: "112.609",
                        x2: "507.02",
                        y2: "216.788",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint12_linear_193_1319",
                        x1: "507.015",
                        y1: "115.462",
                        x2: "507.015",
                        y2: "212.353",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint13_linear_193_1319",
                        x1: "507.015",
                        y1: "166.104",
                        x2: "507.015",
                        y2: "211.824",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint14_linear_193_1319",
                        x1: "603.404",
                        y1: "113.437",
                        x2: "603.404",
                        y2: "217.616",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint15_linear_193_1319",
                        x1: "602.339",
                        y1: "116.29",
                        x2: "602.339",
                        y2: "213.181",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint16_linear_193_1319",
                        x1: "602.169",
                        y1: "158.636",
                        x2: "602.169",
                        y2: "211.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint17_linear_193_1319",
                        x1: "426.087",
                        y1: "115.186",
                        x2: "426.087",
                        y2: "219.365",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint18_linear_193_1319",
                        x1: "426.087",
                        y1: "118.039",
                        x2: "426.087",
                        y2: "214.93",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint19_linear_193_1319",
                        x1: "426.087",
                        y1: "157.342",
                        x2: "426.087",
                        y2: "213.631",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint20_linear_193_1319",
                        x1: "224.526",
                        y1: "113.767",
                        x2: "224.526",
                        y2: "220.175",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint21_linear_193_1319",
                        x1: "224.526",
                        y1: "117.19",
                        x2: "224.526",
                        y2: "214.485",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint22_linear_193_1319",
                        x1: "192.898",
                        y1: "167.956",
                        x2: "192.898",
                        y2: "215.993",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint23_linear_193_1319",
                        x1: "256.365",
                        y1: "168.755",
                        x2: "256.365",
                        y2: "216.003",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint24_linear_193_1319",
                        x1: "340.088",
                        y1: "114.207",
                        x2: "340.088",
                        y2: "220.615",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint25_linear_193_1319",
                        x1: "340.088",
                        y1: "117.63",
                        x2: "340.088",
                        y2: "214.926",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint26_linear_193_1319",
                        x1: "340.088",
                        y1: "162.841",
                        x2: "340.088",
                        y2: "215.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_193_1319",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "669",
                            height: "149",
                            fill: "white",
                            transform: "translate(147 112)"
                        })
                    })
                ]
            })
        ]
    }));
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
